import React from "react";

function Footer() {
  return (
    <div className="container footer mt-4">
      <div className="row d-flex justify-content-center">
        <strong>
          <h6 className="text-center">
            Challenge by <a target="_blank" rel="noreferrer" href="https://www.frontendmentor.io/challenges/rest-countries-api-with-color-theme-switcher-5cacc469fec04111f7b848ca">FrontendMentor</a>
            . Coded by <a target="_blank" rel="noreferrer" href="https://github.com/lamaolo">
              Lucero Amaolo
            </a>
            .
          </h6>
        </strong>
      </div>
    </div>
  );
}

export default Footer;
